import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
export const auditEntryDto = z.object({
    id: uuid,
    at: isoDateTime,
    actorId: uuid.nullable(),
    actorName: z.string(),
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    summary: z.string(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    ip: z.string().nullable(),
});
export const auditQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
    actorId: uuid.optional(),
    action: z.string().optional(),
    entityType: z.string().optional(),
    from: isoDateTime.optional(),
    to: isoDateTime.optional(),
    q: z.string().max(200).optional(),
});
//# sourceMappingURL=audit.js.map